module.exports = __webpack_public_path__ + "static/media/education.237f4859.svg";